import React from 'react';
import { RedirectionButton } from './components/Button';
import { Container } from './components/Container';
import { CommonComponent, CommonComponentContent } from './components/CommonComponent';

const classNames = require('html-classnames');

export interface ArticleContentProps {
  image?: string;
  date?: string;
  title: string,
  content: Array<CommonComponentContent>,
}

export const ArticleContent: React.FC<ArticleContentProps> = ({
  image, date, title, content,
}) => (
  <main className="page">
    <div
      className={classNames('page__top_unit', {
        '--with-contrast-headline': !image,
      })}
      style={image ? { backgroundImage: `url(${image})`, backgroundColor: 'rgba(0, 0, 0, 0.3)' } : undefined}
    >
      <div className="page__nav_title_container">
        <div className="page__navigation">
          <RedirectionButton
            url="/filary"
            color="#FAFAFA"
            text="Filary naszej polityki"
          />
        </div>
        {date && <div className="article__date">{new Date(date).toLocaleDateString('pl-PL')}</div>}
        <h1 className="article__title">{title}</h1>
      </div>
    </div>
    <Container className="page__text">
      {content?.map((c, i) => <CommonComponent key={i} {...c} />)}
    </Container>
  </main>
);
